module.exports = __webpack_public_path__ + "img/index_croll.2c31d656.png";